import { routes } from '@/assets/constants/routes-no.ts';
import { Testimonials } from '@/components/testimonials/testimonials.tsx';
import {
  competitionWinnersQuery,
  getActiveCompetition,
  testimonialsQuery,
} from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';
import { SEO } from '@/lib/seo.tsx';

import ActionButton from '../../components/ActionButton/index.ts';
import Circle from '../../components/Circle/index.ts';
import PartnerBanks from '../../components/PartnerBanks/index.ts';
import Partners from '../../components/Partners/index.ts';
import RrsHandler from '../../components/RrsHandler/index.ts';
import Section from '../../components/Section/index.ts';
import SectionTitle from '../../components/SectionTitle/index.ts';

import type { Route } from './+types/Home';
import HeroDoodle from './_components/HeroDoodle/index.ts';
import StaticSaveWithScoopr from './_components/StaticSaveWithScoopr/index.ts';
import { RRS_HOME } from './RRS.ts';

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const activeCompetition = await getActiveCompetition(competitions);
  const testimonials = await queryClient.query(testimonialsQuery());
  return { activeCompetition, testimonials };
}

export default function Home({ loaderData }: Route.ComponentProps) {
  return (
    <>
      <SEO
        title="Refinansiering og lavere rente på lån"
        description="Se hva du kan spare på å samle forbrukslån og kredittkort. Én søknad til 13 banker med BankID. Helt gratis og uforpliktende."
        path={routes.HOME}
      />
      <RrsHandler {...RRS_HOME} />
      <HeroDoodle activeCompetition={loaderData.activeCompetition} />
      <Section background="paper">
        <StaticSaveWithScoopr />
      </Section>
      <Section background="paper">
        <Partners />
      </Section>

      <Section background="paper">
        <PartnerBanks
          variant="unicolored"
          data={[
            { name: 'avida', linkEnabled: true },
            { name: 'brabank', linkEnabled: false },
            { name: 'expressbank', linkEnabled: true },
            { name: 'ikanobank', linkEnabled: true },
            { name: 'instabank', linkEnabled: false },
            { name: 'morrowbank', linkEnabled: true },
            { name: 'remember', linkEnabled: false },
            { name: 'resursbank', linkEnabled: true },
            { name: 'nordax', linkEnabled: true },
            { name: 'santander', linkEnabled: false },
            { name: 'svea', linkEnabled: true },
            { name: 'tfbank', linkEnabled: true },
            { name: 'ya', linkEnabled: true },
          ]}
          isRefin
        />
      </Section>

      <Section background="paper">
        <Testimonials data={loaderData.testimonials} />
      </Section>

      <Section extraPadding>
        <Circle position="topLeft" />
        <Circle position="bottomRight" />
        <SectionTitle
          title="Hvor mye kan du spare i dag?"
          subtitle="Se om du kan få en bedre deal på refinansiering."
        />
        <ActionButton label="Sjekk nå" step="skip_start" flow="debt_check" color="secondary" />
      </Section>
    </>
  );
}
